import React, { useState } from "react";

import eyeHide from "../../assets/settings/eye-password-hide.svg";
import eyeOpen from "../../assets/settings/eye-icon.svg";

const AppTextField = ({
  id,
  label,
  type = "text",
  name,
  error = "",
  required = false,
  className = "",
  inputClassName = "",
  value = "",
  maxLength = "",
  onChange = () => {},
  onInput = () => {},
  errorMessage = "",
  validator = () => {},
  isDisplayErrorInLabel = false,
  ...props
}) => {
  // const [hasError, setHasError] = useState(false);
  // const [error, setError] = useState(errorMessage);
  // const onChangeHandler = (e) => {
  //   var htmlRegexG = /<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>/g;
  //   e.target.value = e.target.value.replace(htmlRegexG, "");
  //   const inputValue = e.target.value;
  //   console.log("inputValue", inputValue);
  //   const validationError = validator(inputValue);
  //   if (validationError) {
  //     setHasError(true);
  //     setError(validationError);
  //   } else {
  //     setHasError(false);
  //     setError("");
  //   }
  //   onChange(e);
  // };
  const [isPasswordVisible, setIsPasswordVisible] = useState(
    type === "password" ? false : true
  );
  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const onChangeHandler = (e) => {
    const inputValue = e.target.value;
    const validationError = validator(inputValue);
    if (validationError) {
      // setHasError(true);
      // setError(validationError);
    } else {
      // setHasError(false);
      // setError("");
    }
    onChange(e);
  };

  return (
    <div>
      {label && (
        <label
          htmlFor={name}
          className={`block text-[14px] text-[#808080] text-left relative ${className}
        ${isDisplayErrorInLabel && "text-red-500"}
        `}
        >
          {label}
        </label>
      )}
      <div className="relative">
        <input
          id={id}
          type={isPasswordVisible ? "text" : "password"}
          name={name}
          required={required}
          className={`mt-1 block w-full px-3 py-[10px] border text-xs border-insightful-light-gray rounded-md shadow-sm focus:outline-none sm:text-sm ${inputClassName}`}
          value={value}
          maxLength={maxLength}
          onChange={onChangeHandler}
          onInput={onInput}
          autoComplete="off"
          {...props}
        />
        {type === "password" && (
          <button
            type="button"
            onClick={togglePasswordVisibility}
            className="absolute inset-y-0 right-0 flex items-center pr-3"
          >
            {isPasswordVisible ? (
              <span role="img" aria-label="Hide password">
                <svg
                  className="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                  />
                </svg>
              </span>
            ) : (
              <span role="img" aria-label="Show password">
                <img
                  src={eyeHide}
                  alt="mobile settings icon"
                  className="z-10"
                />
              </span>
            )}
          </button>
        )}
      </div>
      {error && (
        <div className="text-red-500 text-xs mt-1 text-left">{error}</div>
      )}
    </div>
  );
};

export default AppTextField;
